import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./GitHubDashboard.css";

// Import icons
import userIcon from "../assets/icons/light/user-icon.png";
import reposIcon from "../assets/icons/light/repos-icon.png";
import issuesIcon from "../assets/icons/light/issues-icon.png";
import prsIcon from "../assets/icons/light/prs-icon.png";
import gitProductivityIcon from "../assets/icons/light/git-productivity-icon.png";

function GitHubDashboard() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalUsers, setTotalUsers] = useState(0);

  // Fetch users from GitHub API
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const githubOrg = process.env.REACT_APP_GITHUB_ORG;
      const response = await fetch(`https://api.github.com/orgs/${githubOrg}/members`, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`, // GitHub API token from environment variable
          Accept: "application/vnd.github.v3+json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch users");

      const data = await response.json();
      setUsers(data);
      setTotalUsers(data.length);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  return (
    <Box className="dashboard-container">
      {/* Back Button */}
      <Box className="github-back-button" onClick={() => navigate(-1)}>
        &lt; Back
      </Box>
      
      {/* Breadcrumb */}
      <Box className="breadcrumb">
        <span className="breadcrumb-link" onClick={() => navigate('/home')}>Dashboard</span>
        <span className="breadcrumb-separator"> &gt; </span>
        <span className="breadcrumb-link" onClick={() => navigate('/monitoring-dashboard')}>Monitoring</span>
        <span className="breadcrumb-separator"> &gt; </span>
        <span className="breadcrumb-text">GitHub Monitoring</span>
      </Box>
      
      {/* Title and Description */}
      <Box className="title-section">
        <h1 className="dashboard-title">Github Monitoring</h1>
        <p className="dashboard-description">
          <strong>Monitor activity across your GitHub organization — users, repos, issues, and PRs.</strong><br />
          Gain insights into contributions, productivity, and collaboration health in real time.
        </p>
      </Box>

      {/* Navigation Buttons (4 per row) */}
      <Box className="button-container">
        <button className="styled-button" onClick={() => navigate("/users")}>
          <img src={userIcon} alt="Users" style={{ width: '24px', height: '24px' }} />
          <span>Users</span>
        </button>
        <button className="styled-button" onClick={() => navigate("/repositories")}>
          <img src={reposIcon} alt="Repositories" style={{ width: '24px', height: '24px' }} />
          <span>Repositories</span>
        </button>
        <button className="styled-button" onClick={() => navigate("/issues")}>
          <img src={issuesIcon} alt="Issues" style={{ width: '24px', height: '24px' }} />
          <span>Issues</span>
        </button>
        <button className="styled-button" onClick={() => navigate("/pull-requests")}>
          <img src={prsIcon} alt="Pull Requests" style={{ width: '24px', height: '24px' }} />
          <span>PRs</span>
        </button>
        <button className="styled-button" onClick={() => navigate("/dialy-productivity")}>
          <img src={gitProductivityIcon} alt="GitHub Productivity" style={{ width: '24px', height: '24px' }} />
          <span>GitHub Productivity</span>
        </button>
      </Box>

      {/* User Table Section */}
      {loading && <CircularProgress />}
      {!loading && users.length > 0 && (
        <Box className="table-wrapper">
          <Typography variant="h6">Total Users: {totalUsers}</Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>S.No</strong></TableCell>
                  <TableCell><strong>Username</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user, index) => (
                  <TableRow key={user.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <a href={user.html_url} target="_blank" rel="noopener noreferrer">
                        {user.login}
                      </a>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}


    </Box>
  );
}

export default GitHubDashboard;
